import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../lib/theme';
import { Button } from '../ui';

export function ThemeToggle() {
  const { theme, setPref } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <Button
      variant="ghost"
      iconOnly
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      onClick={() => setPref(next)}
      icon={theme === 'dark' ? <Sun /> : <Moon />}
    />
  );
}
